/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// This is really just a well-documented object, so we refrain from tests and stories here
// @flow
import * as React from 'react';
import { localize } from '@ta/common.i18n';

/** A component that navigates users to places where they can add content */

export type DefaultActionType = 'Feedback' | 'Review' | 'Photo' | 'Video' | 'LinkPost' | 'Trip';
/** The PID associated with signing in when trying to do certain actions */
export const LoginPID: { [DefaultActionType]: number } = { Photo: 40467, Review: 40468 };

type BaseAction = {|
  label: string,
  icon: string,
  trackingName?: string,
  loginPid?: number,
  pid?: number,
  onClick?: (SyntheticEvent<*>) => void,
|};

type UrlAction = {|
  ...BaseAction,
  url: string,
|};

type OverlayAction = {|
  ...BaseAction,
  name: string,
  overlay: () => React.Element<*>,
|};

/** The action */
export type UgcAction = BaseAction | UrlAction | OverlayAction;

/**
 * @ Deprecated: This isn't particularly useful, since consumers almost always want some sort of custom logic.
 * Making every default content type live here introduces unwanted package dependencies
 * */
export default (type: DefaultActionType) => {
  const pid = LoginPID[type];
  switch (type) {
    case 'Feedback': {
      const emailAddress = 'userfeedback-svc@tripadvisor.com';
      const subject = localize('mobile_feedback_subject'); // TripAdvisor beta feedback
      const bodyInfo = localize('mobile_feedback_body_info'); // Please provide feedback or describe the issue you are experiencing here:
      const mailToComposed = `mailto:${emailAddress}?subject=${subject}&body=${bodyInfo}`;
      return {
        label: localize('mobile_feedback_title'), // Send beta feedback
        icon: 'email-fill',
        url: mailToComposed,
        pid,
      };
    }
    case 'Review': {
      throw new Error('Default review option is no longer supported.');
    }
    case 'Photo': {
      throw new Error('Default photo option is no longer supported.');
    }
    case 'Video': {
      throw new Error('Default video option is no longer supported.');
    }
    case 'LinkPost': {
      throw new Error('Default link post option is no longer supported.');
    }
    case 'Trip':
      return {
        label: localize('ugc_uploader_trip_v2'), // Create trip
        icon: 'my-trips',
        pid,
        url: '/Profile', // TODO: Hook this up with create trip action
      };
    default:
      throw new Error(`${type} is not a valid ActionType`);
  }
};
